<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16slRML/tc-custom/9781547538256.jpg?1692614730303" alt="This image is the cover for the book Tentáculos invasores"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tentáculos invasores
      </h1>
      <p class="bookDescription body article font2">
        <p>Un gran meteorito se ha estrellado en Kenosha, Wisconsin. Curioso por el cráter que dejó el meteorito, un estudiante universitario va a examinar el accidente. Cuando recoge una piedra de aspecto extraño para llevar a casa como un recuerdo, poco sabe él que algo peligroso reside en su interior.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K. Matthew, Luisa Maria Reyes Cortés
      </h2>
      
      <p class="authorDescription body article">K. Matthew escribe historias de romances vapososos en una variedad de géneros.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e01fed3